import React, { Component } from 'react';
import PSPDFKit from '../pspdfkit';
import queryString from 'query-string';
import { getDocumentArrayBufferExternal } from '../../api/external';
import AuthService from '../externalauthentication/authservice.js';
import { isModernApi } from '../..';
import { getCookie, setCookie } from '../termsofuse/utils';
import { TOS_VERSION } from '../termsofuse/termsofusearchive';
import TosModal from '../fillableform/termsofusemodal';
import jwt from 'jsonwebtoken';

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

const base64ToArrayBuffer = base64 => {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
};

export class LegacyViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      presets: {},
      userId: '',
      districtName: ''
    };
    this.acceptTerms = this.acceptTerms.bind(this);
    // this.internalSaveAnnotations = this.internalSaveAnnotations.bind(this);
  }

  async componentDidMount() {
    const documentId = this.props.match.params.superid;

    let pdfContent = null;

    try {
      const auth = new AuthService();
      console.log('legacy created auth');
      const user = await auth.getUser();
      pdfContent = await getDocumentArrayBufferExternal(user, documentId);
      const isModern = isModernApi();
      let showModal = false;
      let districtName = '';
      let hidePrintButton = false;
      if (isModern) {
        const token = jwt.decode(user.access_token);
        console.log('token', token);
        districtName = token.s_accountDisplay;
        hidePrintButton =
          token.s_permissions && token.s_permissions.enableInternalPrintButton
            ? true
            : false;
        console.log('*********** got it', districtName);
        const cookie = getCookie(`ARCHIVE_TOS_${TOS_VERSION}`);
        if (!cookie || cookie !== 'accepted') {
          showModal = true;
        }
      }
      this.setState((state, props) => {
        return {
          finishedLoading: true,
          pdfContent,
          isModern,
          showModal,
          districtName,
          hidePrintButton
        };
      });
    } catch (error) {
      console.log('caught error');
      console.log(error);
      this.setState((state, props) => {
        return {
          error: true,
          errorMessage: error
        };
      });
    }
  }

  acceptTerms() {
    setCookie(`ARCHIVE_TOS_${TOS_VERSION}`, 'accepted', 365);
  }

  render() {
    let licenseKey = process.env.REACT_APP_PSPDFKIT_LICENSE;
    console.log(this.state.finishedLoading);
    return (
      <div className="App">
        {this.state.finishedLoading && (
          <PSPDFKit
            documentId={this.props.match.params.superid}
            pdfUrl={this.state.pdfContent}
            licenseKey={licenseKey}
            baseUrl={baseUrl}
            client={'demoso.scribonline.com'}
            hideToolbar={true}
            isExternal={true}
            hidePrint={this.state.hidePrintButton}
          />
        )}
        {this.state.isModern && (
          <TosModal
            modal={this.state.showModal}
            onConfirm={this.acceptTerms}
            client={'docmanagement.parchment.com'}
            districtName={this.state.districtName}
          />
        )}
      </div>
    );
  }
}

export default LegacyViewer;
